export default function DataCard({
                                     title,
                                     items = [],
                                     add = false,
                                     editable = false, // global editable toggle
                                     onAdd,
                                     onRemove,
                                     onChange,
                                     onSave,
                                     children,
                                 }) {
    const handleChange = (key, value) => {
        if (onChange) onChange(key, value);
    };

    const renderInput = (item) => {
        const type = item?.format?.type ?? "text";

        // Handle select type
        if (type === "select") {
            const opts = item.format?.options;
            const source = opts?.source ?? [];
            const keyField = opts?.key ?? "id";
            const valueField = opts?.value ?? "name";

            return (
                <select
                    className="form-select ms-2"
                    style={{maxWidth: "250px"}}
                    value={item.value ? JSON.stringify(item.value) : ""}
                    onChange={(e) => {
                        const selected = e.target.value ? JSON.parse(e.target.value) : null;
                        handleChange(item.key, selected);
                    }}
                >
                    <option value="">Select...</option>
                    {source.map((opt) => (
                        <option key={opt[keyField]} value={JSON.stringify(opt)}>
                            {opt[valueField]}
                        </option>
                    ))}
                </select>

            );
        }

        if (type === "bool") {
            return (
                <div className="form-check form-switch ms-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`switch-${item.key}`}
                        checked={!!item.value}
                        onChange={(e) => handleChange(item.key, e.target.checked)}
                    />
                </div>
            );
        }

        // Handle default input types (text, number, date, etc.)
        return (
            <input
                type={type}
                className="form-control ms-2"
                value={item.value ?? ""}
                onChange={(e) => handleChange(item.key || item.label, e.target.value)}
                style={{maxWidth: "250px"}}
            />
        );
    };

    return (
        <div className="card mt-3 shadow-sm">
            <div className="card-body">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title mb-0">{title}</h5>
                    <div className="d-inline-flex gap-2">
                        {add && (
                            <button className="btn btn-primary btn-sm" onClick={onAdd}>
                                + Add
                            </button>
                        )}
                        {onRemove && (
                            <button className="btn btn-danger btn-sm" onClick={onRemove}>
                                Delete
                            </button>
                        )}
                    </div>
                </div>

                {/* Content */}
                <div className="card-text">
                    {items.length ? (
                        <ul className="list-unstyled mb-0">
                            {items.map((item, i) => {
                                const isEditable = item.editable ?? editable;
                                return (
                                    <li key={i} className="mb-2 d-flex align-items-center">
                                        <strong style={{ width: "120px" }}>{item.label}:</strong>
                                        {isEditable ? (
                                            renderInput(item)
                                        ) : (
                                            <span className="ms-2">
                                                {item.value !== null && item.value !== undefined
                                                    ? item.value
                                                    : "—"}
                                            </span>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    ) : (
                        <p className="text-muted mb-0">No data available.</p>
                    )}

                    {children}
                </div>

                {(editable || items.some((i) => i.editable)) && (
                    <div className="d-flex flex-end">
                        <button
                            className="btn btn-success mt-3 fw-bold"
                            style={{ marginLeft: "auto" }}
                            onClick={onSave}
                        >
                            Save
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
